import PopupFeature from 'ol-ext/overlay/PopupFeature';
import Select from 'ol/interaction/Select';
import { singleClick } from 'ol/events/condition';
import { Style, Circle, Fill, Stroke } from 'ol/style';
import { selectDataStyleFunctionEN, selectDataStyleFunctionPL } from './source';
import { permalinkFeature } from './datepicker';
import { loadLanguageOL } from './translations';

// Select  interaction
export var selectfeature = new Select({
    hitTolerance: 5,
    multi: true,
    condition: singleClick,
    style: selectDataStyleFunctionEN,
    layers: function (layer) {

        if (layer.getProperties().layerName == 'itineraryEntries')
            return true;
    },
});

export var templateEn = {
    title:
        function (f) {
            return f.get('place_name_caption_form')

        },
    attributes: {
        'date_DESCRIPTIVELY': {
            title: 'date_DESCRIPTIVELY',
            format: function (val, f) {
                if (f.get('date_DESCRIPTIVELY') == '')
                    return f.get('START_date')
                else
                    return f.get('date_DESCRIPTIVELY')
            },
        },
        'Entry_note': {
            title: 'Entry note',
        },
        'Place_note': {
            title: 'Place note',
        },
        'IDI': {
            title: 'Itinerary website',
            format: function (val, f) {
                return '<a href=' + f.get('IDI') + ' target="_blank">IDI [' + f.get('IDI_No') + ']</a>'
            },
        },
    }
};

export var templatePl = {
    title:
        function (f) {
            return f.get('place_name_caption_form_pl')

        },
    attributes: {
        'date_DESCRIPTIVELY_PL': {
            title: 'date_DESCRIPTIVELY_PL',
            format: function (val, f) {
                if (f.get('date_DESCRIPTIVELY_PL') == '')
                    return f.get('START_date')
                else
                    return f.get('date_DESCRIPTIVELY_PL')
            },
        },
        'Entry_note_pl': {
            title: 'Notka',
        },
        'Place_note_pl': {
            title: 'Informacje o miejscu',
        },
        'IDI': {
            title: 'Itinerary website',
            format: function (val, f) {
                return '<a href=' + f.get('IDI') + ' target="_blank">IDI [' + f.get('IDI_No') + ']</a>'
            },
        },
    }
}


// Select places control
export var popup = new PopupFeature({
    popupClass: 'default anim',
    select: selectfeature,
    canFix: true,
    maxChar: 1000,
    closeBox: true,
    positionning: 'auto',
    minibar: false,
    template: templateEn,
    onshow: function () {

        $('.ol-fix').attr('data-bs-toggle', "tooltip");

        if ($('.ol-popup').hasClass('ol-fixed')) {
            $('head').append('<style>.ol-fix:before{border-right-width:unset !important; border-left-width:.6em !important; border-color: #718069 !important;}</style>');
            if (permalinkFeature.getUrlParam('lang') == 'en') {
                $('.ol-fix').attr('data-bs-original-title', loadLanguageOL('en', "tooltip-undock"));


            } else {
                $('.ol-fix').attr('data-bs-original-title', loadLanguageOL('pl', "tooltip-undock"));


            }

        }
        else {

            $('head').append('<style>.ol-fix:before{border-right-width:.6em !important; border-left-width:unset !important; border-color: #6c757d !important;}</style>');
            if (permalinkFeature.getUrlParam('lang') == 'en') {
                $('.ol-fix').attr('data-bs-original-title', loadLanguageOL('en', "tooltip-dock"));


            } else {
                $('.ol-fix').attr('data-bs-original-title', loadLanguageOL('pl', "tooltip-dock"));


            }

        }

        var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
        var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
            return new bootstrap.Tooltip(tooltipTriggerEl, {
                customClass: 'custom-tooltip',
                animated: 'fade',
                placement: 'bottom',
                trigger: 'hover'
            })
        })


    }
});

$(document).on('click', '.ol-popup', function () {

    $('.ol-fix').attr('data-bs-toggle', "tooltip");

    if ($('.ol-popup').hasClass('ol-fixed')) {
        $('head').append('<style>.ol-fix:before{border-right-width:unset !important; border-left-width:.6em !important; border-color: #718069 !important;}</style>');
        if (permalinkFeature.getUrlParam('lang') == 'en') {
            $('.ol-fix').attr('data-bs-original-title', loadLanguageOL('en', "tooltip-undock"));


        } else {
            $('.ol-fix').attr('data-bs-original-title', loadLanguageOL('pl', "tooltip-undock"));


        }

    }
    else {

        $('head').append('<style>.ol-fix:before{border-right-width:.6em !important; border-left-width:unset !important; border-color: #6c757d !important;}</style>');
        if (permalinkFeature.getUrlParam('lang') == 'en') {
            $('.ol-fix').attr('data-bs-original-title', loadLanguageOL('en', "tooltip-dock"));


        } else {
            $('.ol-fix').attr('data-bs-original-title', loadLanguageOL('pl', "tooltip-dock"));


        }

    }

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
    var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new bootstrap.Tooltip(tooltipTriggerEl, {
            customClass: 'custom-tooltip',
            animated: 'fade',
            placement: 'bottom',
            trigger: 'hover'
        })
    })


});